import React from "react";
import "./Banner.css"; 

function Banner({ text, subtext }) {
  return (
    <section className="banner">
      <h2>{text}</h2>
      <p>{subtext}</p>
    </section>
  );
}

export default Banner;
